import React from 'react';
import SvgIcon from './SvgIcon';

const Insights = props => (
    <SvgIcon width="17" height="18" viewBox="2 0 13 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            stroke="none"
            d="M5.18389 1.8907C7.14062 0.404601 9.85332 0.424579 11.7879 1.93934L11.9475 2.06424C12.7065 2.65851 13.2825 3.45472 13.6096 4.36151C14.2037 6.00901 13.9157 7.84581 12.8459 9.23241L10.7813 11.9082V13.5C10.7813 14.0523 10.3336 14.5 9.78127 14.5H7.21877C6.66649 14.5 6.21877 14.0523 6.21877 13.5V11.9082L4.16225 9.24285C3.0871 7.84939 2.79019 6.00648 3.37332 4.34587C3.71068 3.38515 4.3228 2.54469 5.13367 1.92884L5.18389 1.8907ZM11.1715 2.72671C9.59461 1.49207 7.38358 1.47579 5.78871 2.68706L5.73849 2.7252C5.08363 3.22256 4.58929 3.90131 4.31684 4.67719C3.84591 6.01829 4.08568 7.50662 4.95398 8.63197L7.09893 11.4119C7.17663 11.5126 7.21877 11.6362 7.21877 11.7634V13.5H9.78127V11.7632C9.78127 11.6362 9.82337 11.5127 9.90097 11.4121L12.0541 8.62153C12.9153 7.50541 13.1471 6.02689 12.6689 4.70077C12.4056 3.97086 11.9419 3.32995 11.331 2.85161L11.1715 2.72671Z"
        />
        <path
            stroke="none"
            d="M7.00003 15.5C7.00003 15.2239 7.22389 15 7.50003 15H9.50003C9.77617 15 10 15.2239 10 15.5C10 15.7761 9.77617 16 9.50003 16H7.50003C7.22389 16 7.00003 15.7761 7.00003 15.5Z"
        />
        <path
            stroke="none"
            d="M7.50003 17C7.50003 16.7239 7.72389 16.5 8.00003 16.5H9.00003C9.27617 16.5 9.50003 16.7239 9.50003 17C9.50003 17.2761 9.27617 17.5 9.00003 17.5H8.00003C7.72389 17.5 7.50003 17.2761 7.50003 17Z"
        />
        <path
            stroke="none"
            d="M9.49477 8.48643C9.49477 9.00965 9.07062 9.4338 8.54741 9.4338C8.02419 9.4338 7.60004 9.00965 7.60004 8.48643C7.60004 7.96321 8.02419 7.53906 8.54741 7.53906C9.07062 7.53906 9.49477 7.96321 9.49477 8.48643Z"
        />
        <path
            stroke="none"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.50006 3.25C8.91427 3.25003 9.25003 3.58585 9.25 4.00006L8.7912 6.80691C8.76794 6.94925 8.64495 7.05374 8.50072 7.05371C8.35662 7.05367 8.23374 6.94928 8.21041 6.80707L7.75 3.99994C7.75003 3.58573 8.08585 3.24997 8.50006 3.25Z"
        />
    </SvgIcon>
);

Insights.displayName = 'InsightsIcon';

export default Insights;
